module.exports = __webpack_public_path__ + "img/icon-energy-dryer.8c387689.svg";